module.exports = __webpack_public_path__ + "img/dynamic-30.a3c435f1.png";